export default class LinkHighlight {
	
	static clearLinks(html) {
		if (!html) return;
		let linkRegexp = /<a[\s]+(href="\/article-view\?id=[a-z0-9]+&amp;resume=[a-z0-9]+")([^>]+)>((?:.(?!<\/a>))*.)<\/a>/;
		let regexpHasMatches = true;

		//while links to other articles are found
		//replace the links with text only.
		while (regexpHasMatches) {
			let match = linkRegexp.exec(html);
			if (match && match[3]) {
				html = html.replace(linkRegexp, match[3]);
				regexpHasMatches = linkRegexp.test(html);
			} else {
				break;
			}
		}

		return html;
	}

	constructor(html, articlesMinimal, articleId) {
		this.html = html;
		this.articlesMinimal = articlesMinimal;
		this.articleId = articleId;
		this.htmlWithLinks = '';
		this.headerCache = {
			h2:[],
			h3:[]
		};
	}

	getHighlightHtml() {
		this.highlightLinks();
		return this.htmlWithLinks;
	}

	highlightLinks() {
		let relArts = this.articlesMinimal;
		let html = this.html;
		if (!relArts) {
			this.htmlWithLinks = html;
			return;
		}
		if(!this.articlesMinimal) {
			this.htmlWithLinks = html;
			return;
		}
		if (this.articlesMinimal.some(a=> a.title.length == 0)) {
			this.htmlWithLinks = html;
			return;
		}
		html = this.removeHeadings(html);
		let rep = this.getRepStrings(relArts);
		html = this.addPlaceholders(html, rep);
		html = this.replacePlaceholders(html, rep);
		html = this.addHeadings(html);
		this.htmlWithLinks = html;
	}

	replacePlaceholders(html, replaceable) {
		replaceable.forEach((r, i) => {
			let link = `<a href="/article-view?id=${this.articleId}&resume=${r.id}">${r.text}</a>`;
			//this was causing problem in older versions of chrome and firefox
			// html = html.replaceAll(`[[*${i}*]]`, link);
			html = html.split(`[[*${i}*]]`).join(link);
		});

		return html;
	}

	addPlaceholders(html, replaceable) {
		replaceable.forEach((r, i) => {
			//this was causing problem in older versions of chrome and firefox
			// html = html.replaceAll(r.text, `[[*${i}*]]`);
			html = html.split(r.text).join(`[[*${i}*]]`);
		});

		return html;
	}

	getRepStrings(relArts) {
		let replaceable = [];

		relArts.forEach((a) => {
			replaceable.push({ text: a.title, id: a.id });
			if (a.aliases) {
				a.aliases.forEach((al) =>
					replaceable.push({ text: al, id: a.id })
				);
			}
		});

		replaceable.sort((a, b) => {
			return b.text.length - a.text.length;
		});
		replaceable = replaceable.filter(r=>r.text.length > 0);
		return replaceable;
	}

	removeHeadings(html) {
		if (!html) return;

		let h2RegExp = /<h2([^>]+)>(?:.(?!<\/h2>))*.<\/h2>/;
		let h3RegExp = /<h3([^>]+)>(?:.(?!<\/h3>))*.<\/h3>/;

		let hasMatches = true;

		//while links to other articles are found
		//replace the links with text only.
		while (hasMatches) {
			let matchh2 = h2RegExp.exec(html);
			let matchh3 = h3RegExp.exec(html);

			if (matchh2 && matchh2[0]) {
				html = html.replace(h2RegExp, `[[***h2***]]`);
				this.headerCache.h2.push(matchh2[0]);
			} 
			
			if(matchh3 && matchh3[0]) {
				html = html.replace(h3RegExp, `[[***h3***]]`);
				this.headerCache.h3.push(matchh3[0]);
			}

			hasMatches = h2RegExp.test(html) || h3RegExp.test(html);
		}
		
		return html;
	}

	addHeadings(html) {
		if (!html) return;

		let h2RegExp = /\[\[\*\*\*h2\*\*\*\]\]/;
		let h3RegExp = /\[\[\*\*\*h3\*\*\*\]\]/;
		let indexh2 = 0;
		let indexh3 = 0;
		let hasMatches = true;

		//while links to other articles are found
		//replace the links with text only.
		while (hasMatches) {
			let matchh2 = h2RegExp.exec(html);
			let matchh3 = h3RegExp.exec(html);

			if (matchh2 && matchh2[0]) {
				html = html.replace(h2RegExp, this.headerCache.h2[indexh2]);
				indexh2++;
			} 
			
			if(matchh3 && matchh3[0]) {
				html = html.replace(h3RegExp, this.headerCache.h3[indexh3]);
				indexh3++;
			}

			hasMatches = h2RegExp.test(html) || h3RegExp.test(html);
		}
		this.resetCache();
		return html;
	}

	resetCache() {
		this.headerCache = {
			h2: [],
			h3: []
		}
	}

}